import React from 'react';
import KickList from '../KickList';
import styles from './SessionLog.module.css';

export default function SessionLog({ backgroundColor }) {
  return (
    <div className={styles.mainContainer}>
      <div className={styles.titleContainer}>
        <span className={styles.titleItem}>Movement Type</span>
        <span className={styles.titleItem}>Time Elapsed</span>
        <span className={styles.titleItemEmpty} />
      </div>
      <KickList backgroundColor={backgroundColor} />
    </div>
  );
}
